import React, { Component } from 'react'
import "./App.css"
import RootContainer from "./containers/RootContainer";
import { Provider } from "react-redux";
import { initializeStore } from "./redux/store";

export default class App extends Component{
  render(){
    return(
      <Provider store={initializeStore()}>
        <RootContainer />
      </Provider>
    )
  }
}
